export default "__VITE_ASSET__FMXgVGJG__"